import { PublishedResults } from '../../../components/results/shared/PublishedResults';

export default function StudentViewCBT() {
  return <PublishedResults assessmentType="cbt" audience="student" />;
}
